
import axios from 'axios';

export default axios.create({
    baseURL: 'https://dev.futurevisions.tn/api/',
    withCredentials:true,

});